import React from "react";
import BlogBox from "./BlogBox";
import { Link } from "react-router-dom";

export default function HomeBlog() {
  return (
    <>
      <div className="container mx-auto px-6 py-10 home-blog">
        <BlogBox
          category="Industry Connectivity"
          title="Why Traditional Networks Fall Short"
          imgSrc="https://meshmerize.net/wp-content/uploads/2023/08/connectivity-industry-4-1024x614.jpg"
          authorImg="https://blocks.primereact.org/demo/images/blocks/avatars/circle/avatar-f-1.png"
          authorName="FlexNet Team"
          date="Jan 27, 2025"
          link="/blog-single"
        />
        <BlogBox
          category="5G Technology"
          title="5 Real-World Applications of Private 4G/5G Networks"
          imgSrc="https://dgtlinfra.com/wp-content/uploads/2023/05/Examples-of-Private-5G-and-4G-LTE-Networks-Industrial-Internet-of-Things-IIoT.jpg.webp"
          authorImg="https://blocks.primereact.org/demo/images/blocks/avatars/circle/avatar-f-1.png"
          authorName="FlexNet Team"
          date="Jan 28, 2025"
          link="/blog-single2"
        />
        <BlogBox
          category="Edge Computing"
          title="What is Edge Computing?"
          imgSrc="https://dnycf48t040dh.cloudfront.net/What-is-Edge-Computing.jpeg"
          authorImg="https://blocks.primereact.org/demo/images/blocks/avatars/circle/avatar-f-1.png"
          authorName="FlexNet Team"
          date="Jan 29, 2025"
          link="/blog-single3"
        />
      </div>
      <button className="blog-button shadow-lg">
        <Link to="blog-page">Read More</Link>
      </button>
    </>
  );
}
